// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__o1GRX","fileDisabled":"File_fileDisabled__H41E1"};